export const messages = {
  en: {
    adminWorkDetail: {
      title: 'Work Order Details',
      workId: 'Work Order ID',
      workName: 'Work Order Name',
      typeName: 'Type Name',
      workCycle: 'Type',
      once: 'One-time Work Order',
      periodic: 'Periodic Work Order',
      startTime: 'Start Time',
      endTime: 'End Time',
      createUserName: 'Creator',
      curStaffName: 'Processor',
      curCopyName: 'Copy To',
      stateName: 'Status',
      createTime: 'Create Time',
      attachment: 'Attachment',
      content: 'Content',
      processor: 'Processor',
      processContent: 'Process Content',
      copyTo: 'Copy To',
      workFlow: 'Work Flow',
      flowAttachment: 'Flow Attachment',
      workType: 'Work Type',
      taskId: 'Task ID',
      preProcessor: 'Previous Processor',
      taskPeriod: 'Task Period',
      remark: 'Remark',
      finishTime: 'Finish Time',
      copyProcessed: 'Copy Processed',
      processed: 'Processed',
      pending: 'Pending',
      score: 'Score',
      deductionMoney: 'Deduction Amount',
      deductionReason: 'Deduction Reason',
      deductionPerson: 'Deduction Person',
      notifyType: 'Notification Type',
      wechat: 'WeChat',
      sms: 'SMS',
      unknown: 'Unknown',
      completeHours: 'Complete Hours',
      cycle: 'Cycle',
      monthDay: 'Month/Day',
      weekly: 'Weekly',
      month: 'Month',
      day: 'Day',
      week: 'Week',
      fetchError: 'Failed to fetch work order details'
    }
  },
  zh: {
    adminWorkDetail: {
      title: '工作单详情',
      workId: '工单编号',
      workName: '工单名称',
      typeName: '类型名称',
      workCycle: '标识',
      once: '一次性工单',
      periodic: '周期性工单',
      startTime: '开始时间',
      endTime: '结束时间',
      createUserName: '发起人',
      curStaffName: '处理人',
      curCopyName: '抄送人',
      stateName: '状态',
      createTime: '创建时间',
      attachment: '附件',
      content: '内容',
      processor: '处理人',
      processContent: '处理内容',
      copyTo: '抄送人',
      workFlow: '工作单流转',
      flowAttachment: '流转附件',
      workType: '工作单类型',
      taskId: '任务编号',
      preProcessor: '前处理人',
      taskPeriod: '任务有效期',
      remark: '说明',
      finishTime: '完成时间',
      copyProcessed: '抄送人已办理',
      processed: '处理人已办理',
      pending: '待处理',
      score: '评分',
      deductionMoney: '扣款金额',
      deductionReason: '扣款原因',
      deductionPerson: '扣款人',
      notifyType: '通知方式',
      wechat: '微信',
      sms: '短信',
      unknown: '未知',
      completeHours: '完成小时',
      cycle: '周期',
      monthDay: '月/天',
      weekly: '按周',
      month: '月',
      day: '日',
      week: '周',
fetchError: '获取工作单详情失败'
    }
  },
  'zh-TW': {
    adminWorkDetail: {
      title: '工作單詳情',
      workId: '工單編號',
      workName: '工單名稱',
      typeName: '類型名稱',
      workCycle: '標識',
      once: '一次性工單',
      periodic: '周期性工單',
      startTime: '開始時間',
      endTime: '結束時間',
      createUserName: '發起人',
      curStaffName: '處理人',
      curCopyName: '抄送人',
      stateName: '狀態',
      createTime: '創建時間',
      attachment: '附件',
      content: '內容',
      processor: '處理人',
      processContent: '處理內容',
      copyTo: '抄送人',
      workFlow: '工作單流轉',
      flowAttachment: '流轉附件',
      workType: '工作單類型',
      taskId: '任務編號',
      preProcessor: '前處理人',
      taskPeriod: '任務有效期',
      remark: '說明',
      finishTime: '完成時間',
      copyProcessed: '抄送人已辦理',
      processed: '處理人已辦理',
      pending: '待處理',
      score: '評分',
      deductionMoney: '扣款金額',
      deductionReason: '扣款原因',
      deductionPerson: '扣款人',
      notifyType: '通知方式',
      wechat: '微信',
      sms: '短信',
      unknown: '未知',
      completeHours: '完成小時',
      cycle: '周期',
      monthDay: '月/天',
      weekly: '按周',
      month: '月',
      day: '日',
      week: '周',
      fetchError: '獲取工作單詳情失敗'
    }
  }
}